import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import ErrorBoundary from "./components/ErrorBoundary";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import Home from "./pages/Home";
import Menu from "./pages/Menu";
import Checkout from "./pages/Checkout";
import Contact from "./pages/Contact";
import Commandes from "./pages/Commandes";
import { Toaster } from "./components/ui/toaster";

function ScrollTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App bg-[#0c0c0c] min-h-screen">
      <ErrorBoundary>
        <BrowserRouter>
          <CartProvider>
            <ScrollTop />
            <Navbar />
            <CartDrawer />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/carte" element={<Menu />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/commandes" element={<Commandes />} />
            </Routes>
            <Footer />
            <Toaster />
          </CartProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
}

export default App;
